<template>
  <div class="answer-input">
    <van-field
      v-model="data.value"
      rows="3"
      type="textarea"
      placeholder="请在这里填写吧"
      @input="bindInput"
    />
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    bindInput() {
      this.$emit('change', this.data.value)
    }
  }
}
</script>
<style lang="scss" scoped>
.answer-input {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #f1f1f1;
}
</style>
